import { TMutation, TQuery } from 'app/Requests/types';
import httpDriver from 'app/utils/httpDriver';
import { apiRoutes } from '../utils/apiRoutes';
export const handleRegrabHashtag = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().regrabHashtag, {
    hashtag_ids: queryKey[1],
  });
  return data;
};
export const handleDeleteHashtag = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes().deleteHashtag, {
    data: { ids: [id] },
  });
  return { ...data, successMessage };
};

export const handleRestoreHashtag = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().restoreHashtag, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const handleMergeHashtag = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().mergeHashtagsAction, {
    ...body,
  });
  return data;
};

export const handleTrashHashtag = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().trashHashtag, {
    ids: [id],
  });
  return { ...data, successMessage };
};
export const handleTrashUnncessaryHashtag = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().trashunccessaryHashtag, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const unnecessaryHashtags = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().unnecessaryHashtagAction, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const resyncAllHashtags = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().resyncAllHashtags, body);
  return data;
};

export const storeHashtag = async ({
  hashtagName,
  is_keyword,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().storeHashtag, {
    hashtag: hashtagName,
    is_keyword,
  });
  return data;
};
export const convertHashtagToKeyword = async ({
  id,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().convertHashtagToKeyword, {
    id: id,
  });
  return data;
};

export const tweetRelatedHashtags = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().tweetRelatedHashtags,
    queryKey[1],
  );
  return data.payload.records;
};
export const getMostFrequentWords = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().mostFrequentWords,
    queryKey[1],
  );
  return data.payload.records;
};

export const changeTweetType = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().changeTweetType, body);
  return data;
};

export const changeVideoType = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().changeVideoType, body);
  return data;
};

export const changeLinkedInPostsType = async ({
  body,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().changeLinkedInPostsType,
    body,
  );
  return data;
};

export const changeInstagramPostsType = async ({
  body,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().changeInstagramPostsType,
    body,
  );
  return data;
};
export const changeTiktokPostsType = async ({
  body,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().changeTiktokPostsType,
    body,
  );
  return data;
};
export const resyncHashtag = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().regrabHashtag, body);
  return data;
};

export const resyncHashtagPlatforms = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().regrabHashtagPlatforms,
    body,
  );
  return data;
};

export const resyncSingleHashtag = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().regrabHashtag, {
    hashtag_ids: [id],
  });
  return { ...data, successMessage };
};
export const getResyncRelatedHashtags = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().resyncRelatedHashtags, {
    hashtag_id: +id,
  });
  return { ...data, successMessage };
};

export const hashtagWithResnc = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().resncHashtag, body);
  return data;
};

export const loadHashtagView = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().hashtagView, queryKey[1]);
  return data.payload;
};
export const loadSortingOption = async ({ queryKey }: TQuery): Promise<any> => {
  const currentApi =
    queryKey[1] === 0
      ? apiRoutes().twitterSorting
      : queryKey[1] === 1
        ? apiRoutes().videosSorting
        : queryKey[1] === 2
          ? apiRoutes().linkedinSorting
          : queryKey[1] === 3
            ? apiRoutes().instagramSorting
            : apiRoutes().tiktokSorting;
  const { data } = await httpDriver.post(currentApi, queryKey[1]);
  return data.payload.records;
};
export const loadHashtagGrabbingStatus = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().hashtagGrabbingStatus,
    queryKey[1],
  );
  return data.payload;
};

export const handleDownloadSheet = async ({ id }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().downloadSheet, {
    hashtag_id: id,
  });
  return data;
};

export const handleDownloadDetailedSheet = async ({
  id,
  sub_module_name,
  type,
  regrab,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().downloadDetailedReport, {
    report_id: id?.value,
    sub_module_name,
    type,
    regrab: regrab,
  });

  return data;
};
export const handleDownloadFastDetailedSheet = async ({
  item_ids,
  template_id,
  filters,
  sub_module_name,
  type,
  platform_type,
  sub_item_ids,
  bulkFilter,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().downloadFastDetailedReport,
    {
      item_ids,
      template_id,
      ...filters!,
      ...bulkFilter,
      sub_module_name,
      type,
      sub_item_ids,
      platform_type,
      bulkFilter,
    },
  );

  return data;
};
export const handleDownloadGroupFastDetailedReport = async ({
  item_ids,
  template_id,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().downloadGroupFastDetailedReport,
    {
      item_ids,
      template_id,
    },
  );

  return data;
};

export const handleDownloadVersion = async ({
  id,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().downloadReportVersion, {
    version_id: id,
  });

  return data;
};

export const loadHashtagColumns = async ({
  id,
  type,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().loadHashtagData, {
    category_type: type,
    hashtag_id: Number(id),
  });
  return data;
};

export const showHashtag = async ({ id }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().showHashtag, {
    hashtag_id: Number(id),
  });
  return data;
};

export const updateHashtag = async ({
  id,
  hashtagName,
  set_ids,
  words,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes().updateHashtag, {
    hashtag_id: Number(id),
    hashtag: hashtagName,
    set_ids,
    words,
  });
  return data;
};

export const updateHashtagWords = async ({
  id,
  hashtagName,
  set_ids,
  words,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes().addWordsPopup, {
    hashtag_id: Number(id),
    hashtag: hashtagName,
    set_ids,
    words,
  });
  return data;
};
export const fetchRealtedHashtages = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().relatedHashtags,
    queryKey[1],
  );
  return data?.payload?.records;
};
export const fetchFirstMention = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().hashtagFirstMention,
    queryKey[1],
  );
  return data?.payload;
};
export const fetchFrequentWords = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().summaryMostFrequentWords,
    queryKey[1],
  );
  return data?.payload;
};

export const fetchTopLanguages = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().hashtagTopLanguages,
    queryKey[1],
  );
  return data?.payload;
};
export const getInstagramTopLanguage = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().instagramTopLanguage,
    queryKey[1],
  );
  return data?.payload?.records;
};
export const getTypeOfTweetsMedia = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().typeOfTweetsMedia,
    queryKey[1],
  );
  return data?.payload?.records;
};
export const getTweetTopLanguage = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().twitterTopLanguage,
    queryKey[1],
  );
  return data?.payload;
};
export const getLinkedinTopLanguage = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().linkedinTopLanguage,
    queryKey[1],
  );
  return data?.payload?.records;
};
export const getVideosTopLanguage = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().videosTopLanguage,
    queryKey[1],
  );
  return data?.payload?.records;
};
export const getTiktokTopLanguage = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().tiktokTopLanguage,
    queryKey[1],
  );
  return data?.payload?.records;
};
export const fetchTopCountries = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().twitterTopCountries,
    queryKey[1],
  );
  return data?.payload;
};
export const getLastGrabbedOn = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().hashtagsLastGrabbedOn);
  return data?.payload;
};

export const getTweetCardData = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().showTweet, queryKey[1]);
  return data.payload.records;
};
export const getFirstMention = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    !!queryKey[2]
      ? apiRoutes().linkedinFirstMention
      : !!queryKey[3]
        ? apiRoutes().videosFirstMention
        : !!queryKey[4]
          ? apiRoutes().twitterFirstMention
          : !!queryKey[5]
            ? apiRoutes().tiktokFirstMention
            : apiRoutes().instagramFirstMention,
    queryKey[1],
  );
  return data.payload.records;
};

export const getFirstMentionTwitter = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().twitterFirstMention,
    queryKey[1],
  );
  return data.payload.records;
};

export const getFirstMentionLinkedIn = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().linkedinFirstMention,
    queryKey[1],
  );
  return data.payload.records;
};

export const getFirstMentionYoutube = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().videosFirstMention,
    queryKey[1],
  );
  return data.payload.records;
};
export const getFirstMentionTiktok = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().tiktokFirstMention,
    queryKey[1],
  );
  return data.payload.records;
};

export const getFirstMentionInstagram = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().instagramFirstMention,
    queryKey[1],
  );
  return data.payload.records;
};
